export default __webpack_public_path__ + "static/media/busMarkerLight.392f33d1.svg";